import { Injectable, signal, computed } from '@angular/core';
import * as utils from '../../../util';
import { constants } from '../../../constants/constants';

export interface CookieStatus {
	isPresent: boolean;
	isValid: boolean;
	value: string | null;
}

interface DecodedToken {
	exp: number;
	[key: string]: unknown;
}

@Injectable({
	providedIn: 'root',
})
export class CookieMonitorService {
	private readonly monitoringInterval = 1000;
	private readonly accessTokenStatus = signal<CookieStatus>(this.getAccessTokenStatus());

	readonly accessTokenPresent = computed(() => this.accessTokenStatus().isPresent);
	readonly accessTokenValid = computed(() => this.accessTokenStatus().isValid);
	readonly olciDataPresent = computed(() => this.olciDataStatus().isPresent);

	constructor() {
		this.startMonitoring();
	}

	public getCurrentAccessTokenStatus(): CookieStatus {
		return this.accessTokenStatus();
	}

	private startMonitoring(): void {
		setInterval(() => {
			this.checkAccessToken();
		}, this.monitoringInterval);
	}

	private checkAccessToken(): void {
		const status = this.getAccessTokenStatus();
		const currentStatus = this.accessTokenStatus();
		if (
			status.isPresent !== currentStatus.isPresent ||
			status.isValid !== currentStatus.isValid ||
			status.value !== currentStatus.value
		) {
			this.accessTokenStatus.set(status);
		}
	}

	private getAccessTokenStatus(): CookieStatus {
		const cookieValue = utils.readCookie(constants.COOKIES.OLCI.ACCESS_TOKEN);
		const decodedToken = utils.getDecodedAccessToken(constants.COOKIES.OLCI.ACCESS_TOKEN);
		return {
			isPresent: cookieValue !== null && cookieValue !== undefined && cookieValue !== '',
			isValid: decodedToken !== null && decodedToken !== undefined && decodedToken !== '' && !this.accessTokenExpired(decodedToken),
			value: cookieValue,
		};
	}

	private accessTokenExpired(decodedToken: DecodedToken | null): boolean {
		return decodedToken?.exp ? decodedToken.exp * 1000 < Date.now() : true;
	}
	
	private olciDataStatus(): CookieStatus {
		const cookieValue = utils.readCookie(constants.COOKIES.OLCI.OLCI_DATA);
		return {
			isPresent: cookieValue !== null && cookieValue !== undefined && cookieValue !== '',
			isValid: cookieValue !== null && cookieValue !== undefined && cookieValue !== '',
			value: cookieValue,
		};
	}
}
